<template>
    <div class="questions-block">
        <draggable handle=".drag" v-model="questionList" >
            <question v-for="(question,key) in questionList" :question="question" :key="key" :k="key" @remove="remove" @copy="copy" @insert="insert" :edit="edit" :conditionActive="conditionActive"></question>
        </draggable>
    </div>
</template>

<script>

    import Question from "@/components/questionnaire/Question";
    import Btn from "@/components/Btn";
    import tools from '../../config.ts';
    import draggable from 'vuedraggable'

    export default {
        name: "Questions",
        components: {Btn, Question,draggable},
        props:{
            questions:{},
            conditionActive:true,
            edit:false,
        },
        data(){
            return{
                default: {
                    id:0,
                    label: "",
                    type: "none",
                    required:false,
                    resume:false,
                    content: [],
                    conditions: []
                },

                questionsTemps:[],
            }
        },
        methods:{
            add(){
                this.questions.push(JSON.parse(JSON.stringify(this.default)));
                let key = this.questions.length-1;
                this.questions[key].id = this.newId();
                this.questions[key].title = "Question "+(key+1);
                this.questions[key].open = true;

                tools.$emit("updateQuestions")
            },
            insert(k){
                let question = JSON.parse(JSON.stringify(this.default));

                this.questions.splice(k+1,0,question)

                let key = k+1;
                this.questions[key].id = this.newId();
                this.questions[key].title += "Question "+(key+1);
                this.questions[key].open = true;

                tools.$emit("updateQuestions")
            },
            copy(k){
                let question = JSON.parse(JSON.stringify(this.questions[k]));

                this.questions.splice(k+1,0,question)

                let key = k+1;
                this.questions[key].id = this.newId();
                this.questions[key].label += " (copie)";
                this.questions[key].open = true;

                tools.$emit("updateQuestions")
            },
            newId(){
                let newId = 0;

                this.questions.forEach((question) => {
                    if(question.id > newId){
                        newId = question.id;
                    }
                });

                return newId + 1;
            },
            remove(key){
                this.questions.splice(key, 1);

                tools.$emit("updateQuestions")
            },
        },
        computed:{
            questionList:{
                set(questions){
                    this.questionsTemps = questions;
                    tools.$emit("updateQuestions",questions)
                },
                get(){
                    return this.questionsTemps;
                }
            }
        },
        watch:{
            questions(){
                this.questionsTemps = this.questions;
            }
        },
        mounted() {

            tools.$on("addQuestion",() => {
                this.add();
            })

        },
        destroy(){
            tools.$off("addQuestion")
        }
    }
</script>